import { NIGHT } from "../config";

const CSS = `
#world-clock {
  position: fixed;
  top: max(10px, env(safe-area-inset-top));
  right: max(10px, env(safe-area-inset-right));
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 5px 10px 6px;
  border-radius: 2px;
  background: rgba(9, 8, 7, 0.86);
  color: #e9e2d0;
  font-family: "Silkscreen", monospace;
  font-size: 11px;
  line-height: 1;
  letter-spacing: 0.06em;
  font-variant-numeric: tabular-nums;
}
#world-clock[data-night="true"] {
  background: rgba(233, 226, 208, 0.93);
  color: #14120f;
}
#world-clock .orb {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: currentColor;
}
#world-clock[data-flash="true"] .num {
  animation: clock-blink 0.44s ease-in-out 4;
}
@keyframes clock-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.42;
  }
}
#world-clock[data-night="true"] .orb {
  background: transparent;
  box-shadow: inset -3.5px 0 0 0 currentColor;
}
`;

/** a short blink of the hour, to say the time is yours now */
export function flashClock(): void {
  const bar = document.getElementById("world-clock");
  if (!bar) return;
  bar.dataset.flash = "true";
  window.setTimeout(() => {
    bar.dataset.flash = "false";
  }, 3200);
}

export function mountClock(): void {
  const style = document.createElement("style");
  style.textContent = CSS;
  document.head.appendChild(style);

  const bar = document.createElement("div");
  bar.id = "world-clock";
  const orb = document.createElement("span");
  orb.className = "orb";
  const num = document.createElement("span");
  num.className = "num";
  bar.append(orb, num);
  document.body.appendChild(bar);

  const format = (hours: number): string => {
    const total = Math.round(hours * 60) % (24 * 60);
    return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
  };

  interface ClockSource {
    sky: { hours: number; daylight: number; clockOwned: boolean };
  }

  const tick = (): void => {
    const app = (window as unknown as { __explorer?: ClockSource }).__explorer;
    if (app) {
      const { hours, daylight, clockOwned } = app.sky;
      // without a clock in the pack you get the sky, not the hour
      num.textContent = clockOwned ? format(hours) : "";
      bar.dataset.night = daylight < NIGHT.invertBelow ? "true" : "false";
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
}
